// extracted by mini-css-extract-plugin
module.exports = {"chat-buttons":"_21lEu_Xw1rqEWfdiOgEkce","carousel":"DdPEO10si2RkE6xkeHzQ1"};